import { render, staticRenderFns } from "./SelectPaymentMethod.vue?vue&type=template&id=38e55351&scoped=true&"
import script from "./SelectPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./SelectPaymentMethod.vue?vue&type=style&index=0&id=38e55351&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e55351",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
